import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { authHttpClient } from '../../../../../core/infra/http/axios-auth-http-client-adapter';
import { AUTH_API_ROUTES } from '../../api/routes';
import { GetOwners } from './get-owners';

export const getOwnersService: ServiceCommand<GetOwners.Response> =
  new GetOwners(authHttpClient, AUTH_API_ROUTES.GET_OWNERS);

export type { GetOwners };
